import { FormSection } from '@ksyos/design-system';
import type { OsasConsultData } from '@common/validation/customControls/osas/osasConsultSchemas/types';
import type { ValidationErrors } from '@frontend/utils';
import { YesOrNoOrOther } from '@common/enums';
import { OsaNoPolicy } from './OsaNoPolicy';
import { OsaYesPolicy } from './OsaYesPolicy';

export type PolicyFormSectionProps = {
    data: OsasConsultData;
    errors: ValidationErrors;
    onChange: (data: Partial<OsasConsultData>, validateKeys?: string | string[] | undefined) => void;
};

export function PolicyFormSection(props: Readonly<PolicyFormSectionProps>) {
    const { data } = props;

    if ([YesOrNoOrOther.other, null].includes(data.hasOsa)) {
        return null;
    }

    return (
        <FormSection title="Beleid">
            {data.hasOsa === YesOrNoOrOther.no && <OsaNoPolicy {...props} />}
            {data.hasOsa === YesOrNoOrOther.yes && <OsaYesPolicy {...props} />}
        </FormSection>
    );
}
